import DTO from './DTO';
import { required, russianRegNumberWithMask } from '../utils/validation';

class CarDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'vehicle_brand',
        type: String,
        validators: [required],
        labelKey: 'vehicle_brand',
      },
      {
        name: 'vehicle_model',
        type: String,
        validators: [required],
        labelKey: 'vehicle_model',
      },
      {
        name: 'applicant_car_cd_file',
        type: String,
        validators: [required],
        labelKey: 'media.applicant_car_cd_file',
      },
      {
        name: 'car_photo_file',
        type: String,
        validators: [required],
        labelKey: 'media.car_photo_file',
      },
      {
        name: 'ownership_contract_files',
        type: String,
        validators: [required],
        labelKey: 'media.ownership_contract_files',
      },
      {
        name: 'vehicle_year',
        type: String,
        validators: [required],
        labelKey: 'vehicle_year',
      },
      {
        name: 'vehicle_color',
        type: String,
        validators: [required],
        labelKey: 'vehicle_color',
      },
      {
        name: 'vehicle_lpn',
        type: String,
        validators: [required, russianRegNumberWithMask],
        labelKey: 'vehicle_lpn',
      },
      {
        name: 'vehicle_vin',
        type: String,
        validators: [required],
        labelKey: 'vehicle_vin',
      },
      {
        name: 'vehicle_registration_number',
        type: String,
        validators: [required],
        labelKey: 'vehicle_registration_number',
      },
      {
        name: 'vehicle_registration_issue_date',
        type: String,
        validators: [required],
        labelKey: 'vehicle_registration_issue_date',
      },
      {
        name: 'ecology_class',
        type: String,
        validators: [required],
        labelKey: 'ecology_class',
      },
      {
        name: 'has_special_lifting_device',
        type: String,
        validators: [],
        labelKey: 'has_special_lifting_device',
      },
      {
        name: 'special_lifting_device',
        type: String,
        validators: [],
        labelKey: 'has_special_lifting_device',
      },
      {
        name: 'tech_control_address',
        type: String,
        validators: [],
        labelKey: 'tech_control_address',
      },
      {
        name: 'technical_control_address',
        type: String,
        validators: [],
        labelKey: 'tech_control_address',
      },
      {
        name: 'ownership_type',
        type: String,
        validators: [required],
        labelKey: 'ownership_type',
      },
      {
        name: 'ownership_contract_number',
        type: String,
        validators: [required],
        labelKey: 'ownership_contract_number',
      },
      {
        name: 'ownership_contract_effective_date',
        type: String,
        validators: [required],
        labelKey: 'ownership_contract_effective_date',
      },
      {
        name: 'ownership_contract_expiration_date',
        type: String,
        validators: [required],
        labelKey: 'ownership_contract_expiration_date',
      },

    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default CarDTO;
